import axios from "axios";
import * as Cookie from "universal-cookie";

export const API_URL = process.env.REACT_APP_API_URL;

export const fetcher = async (url: string) => {
  const cookie = new Cookie.default();
  const token = cookie.get("userAuthTokenAdmin");
  const res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return res.data;
};

type PostFetcherArgs<T = any> = {
  url: string;
  data?: T;
  method: string;
};

export const patchPostFetcher = async <TResponse = any, TBody = any>({
  url,
  data,
  method,
}: PostFetcherArgs<TBody>): Promise<TResponse> => {
  const cookie = new Cookie.default();
  const token = cookie.get("userAuthTokenAdmin");
  const res = await fetch(url, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: data ? JSON.stringify(data) : undefined,
  });

  if (!res.ok) {
    const error = await res.json();
    throw error;
  }

  return res.json();
};
